define("shared/helpers/format-profile-categorization-value", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f
  function formatProfileCategorizationValue(_ref) {
    let [name, keyword] = _ref;
    const bracketedKeyword = keyword ? ` (${keyword})` : '';
    return `${name}${bracketedKeyword}`;
  }
  var _default = _exports.default = (0, _helper.helper)(formatProfileCategorizationValue);
});